<template>
    <div class="spacer">

        <img src="/static/img/logo.png" class="center-block logo">

        <h2>An error has occured! ({{ code }})</h2>
        <h4 class="my-3">{{ description }}</h4>

        <button class="btn green wide m-5" @click.stop="backHome">
            « Back to Pluralo
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            code: String,
            description: String
        },
        methods: {
            backHome: function() {
                this.$router.push({ name: 'dashboard' });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Error.vue?5997b7f4